export const OFFER_CATEGORIES = ['ROOM', 'ECI', 'LCO', 'ANCILLARY'] as const;

export type OfferCategory = (typeof OFFER_CATEGORIES)[number];

export const OFFER_CATEGORY_ORDER: readonly OfferCategory[] = [
  'ROOM',
  'ECI',
  'LCO',
  'ANCILLARY',
] as const;

export const OFFER_CATEGORY_LABELS: Record<OfferCategory, string> = {
  ROOM: 'Room',
  ECI: 'Early Check-in',
  LCO: 'Late Checkout',
  ANCILLARY: 'Add-ons',
};

// Accept legacy category spellings while migrating older templates and links.
export const OFFER_CATEGORY_ALIASES: Record<string, OfferCategory> = {
  ROOM: 'ROOM',
  ECI: 'ECI',
  LCO: 'LCO',
  ANCILLARY: 'ANCILLARY',
  ADDON: 'ANCILLARY',
  ADDONS: 'ANCILLARY',
};
